var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-auth-card',_vm._g({attrs:{"title":_vm.$t('message.login.secondFactor.configuration.title')}},_vm.$listeners),[_c('nx-auth-second-factor-configuration-form',_vm._g({attrs:{"first-time-configuration":""}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }